import { shipmentStatuses } from '@reveni-io/reveni-ui'

export const shouldShowRating = ({ status, customerRatingBlockEnabled }) => {
  return status === shipmentStatuses.delivered && customerRatingBlockEnabled
}
